'use client';
import { memo } from 'react';
import { useGSAP } from '@gsap/react';
import { Grid, GridItem, Text, VStack } from '@chakra-ui/react';

import { heroAnimation } from 'shared/gsap';
import NextImage from 'shared/NextImage';

import { SECTIONS_IDS } from 'constants/global';
import HeroBg from 'assets/illustrations/heroBg.webp';

const Hero = () => {
  useGSAP(heroAnimation);

  return (
    <Grid
      as="section"
      id={SECTIONS_IDS.hero}
      boxSize="full"
      maxW="1440px !important" // important нужен чтобы предотвратить смещение секции при анимации
      justifyItems="center"
    >
      <GridItem
        area="1 / 1"
        display="flex"
        flexDir="column"
        justifyContent="end"
        w={{ mobile: '146%', tablet: '112%', laptop: 'full' }}
        ml={{ mobile: '-75px', tablet: 'unset' }}
        h={{ mobile: 'calc(100dvh - 155px)', tablet: 'calc(100dvh - 40px)', laptop: '100dvh' }}
        maxH="calc(min(100vw, 1440px) * 149 / 120)"
        minH={{ mobile: '590px', tablet: '600px', laptop: '840px' }}
        zIndex="1"
      >
        {/* TODO: Попробовать уменьшить вес изображения через использование srcset */}
        <NextImage src={HeroBg} alt="Фоновое изображение" w="full" h="auto" />
      </GridItem>

      <GridItem
        area="1 / 1"
        w="full"
        h={{ mobile: '151px', laptop: '294px' }}
        alignSelf="end"
        bg="linear-gradient(0deg, #0E151C 0%, rgba(14, 21, 28, 0.00) 100%)"
        zIndex="2"
      />

      <GridItem
        area="1 / 1"
        boxSize="full"
        display="flex"
        flexDir="column"
        alignItems="start"
        // TODO: придумать как использовать HEADER_HEIGHTS
        pt={{ mobile: '133px', tablet: '102px', laptop: '129px' }}
        px={{ mobile: '16px', tablet: '20px', laptop: '80px' }}
        pb={{ mobile: '16px', tablet: '40px' }}
        gap={{ mobile: '18px', tablet: '16px', laptop: '24px' }}
        zIndex="3"
      >
        <Text
          as="h1"
          id="hero-h1"
          color="ourBlack"
          fontSize={{ mobile: '18px', tablet: '20px', laptop: '30px' }}
          fontWeight="600"
          lineHeight="120%"
          letterSpacing="1%"
          textTransform="uppercase"
          opacity="1"
        >
          Траектория лидерства
        </Text>

        <VStack w="full" align="start" gap={{ mobile: '10px', tablet: '8px', laptop: '10px' }}>
          <Text as="h2" textStyle="h1" id="hero-title" textTransform="uppercase">
            Хватит стоять на старте — <br /> пора управлять
          </Text>

          <Text id="hero-subtitle" textStyle="b1" maxW={{ tablet: '400px', laptop: '740px' }}>
            Карьерная программа ASTON для студентов и выпускников: путь в руководители
          </Text>
        </VStack>
      </GridItem>
    </Grid>
  );
};

export default memo(Hero);
